import livestock from './livestock'

export default
{
    livestock
};
